const allowedDataSources = ['mock', 'api'] as const

export type DataSource = (typeof allowedDataSources)[number]

const resolveDataSource = (): DataSource => {
  const envValue = (import.meta.env.VITE_DATA_SOURCE ?? 'mock').toString().toLowerCase()
  if (allowedDataSources.includes(envValue as DataSource)) {
    return envValue as DataSource
  }
  return 'mock'
}

const resolveBaseUrl = () => {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }
  return '/api'
}

export const apiConfig = {
  dataSource: resolveDataSource(),
  baseUrl: resolveBaseUrl(),
  defaultHeaders: {
    'Content-Type': 'application/json',
  },
} as const

export const dataSourceCacheKey = `${apiConfig.dataSource}:${apiConfig.baseUrl}`

export const isMockDataSource = () => apiConfig.dataSource === 'mock'
